import styled from 'styled-components';
import { VehiclePriceDetailsBlockStyled } from '../VehiclePriceDetailsBlockStyled';
export const VehiclePriceDetailsBlockStyledAC = styled(VehiclePriceDetailsBlockStyled)``;
